import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';

export const StyledBulkInputPlusSignIcon = styled(AddIcon)`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;
